/**
 * @file Cookie Banner.
 */

import { gsap } from 'gsap';
import debounce from 'just-debounce-it';

/**
 * Cookie Banner component.
 */
const vCookieBanner = () => {
	const cookieBanner = document.querySelector('.v-cookie-banner');
	const close = cookieBanner.querySelector('.v-cookie-banner__close');
	const cookieName = 'kv_analytics_consent';
	const consentBtns  = cookieBanner.querySelectorAll('.v-cookie-banner__button');
	const dataLayer  = window.dataLayer || [];
	let seen = !!localStorage.getItem('v_banner_seen') || false;

	/**
	 * Set banner seen.
	 *
	 */
	const setBannerSeen = () => {
		if (seen) {
			return;
		}

		seen = true;
		localStorage.setItem('v_banner_seen', true);
	};

	/**
	 * Whether the user has provided consent before.
	 *
	 * @returns {bool} - Whether or not the user has consented to cookies.
	 */
	const hasPreviousConsent = () => {
		if (wpPostData.envLocation === 'local' || wpPostData.envLocation === 'staging') {
			return seen;
		}

		const cookies = document.cookie.split(';');
		const cookie = cookies.find((c) => c.trim().startsWith(cookieName));
		return !!cookie;
	};

	/**
	 * Close cookie banner..
	 *
	 * @param {object} e - Event.
	 */
	const closeCookieBanner = (e) => {
		e.preventDefault();
		gsap.to(
			cookieBanner,
			{
				y:          100,
				opacity:    0,
				duration:   0.25,
				onComplete: () => {
					cookieBanner.classList.add('v-cookie-banner--closed');
					setBannerSeen();
				},
			},
		);
	};

	/**
	 * Set cookie banner consent.
	 *
	 * @param {object} e - Event.
	 */
	const setCookieBannerConsent = (e) => {
		e.preventDefault();
		const { consent } = e.target.dataset;

		dataLayer.push({
			event:         'consent_update',
			consentStatus: consent.toLowerCase(),
		});
		// setConsentState(consent.toLowerCase());
		closeCookieBanner(e);
	};

	/**
	 * Init.
	 */
	close.addEventListener('click', closeCookieBanner);
	[...consentBtns].forEach((btn) => btn.addEventListener('click', setCookieBannerConsent));

	if (!hasPreviousConsent() && !seen) {
		gsap.from(
			cookieBanner,
			{
				y:        100,
				opacity:  0,
				duration: 0.75,
				onStart:  () => {
					cookieBanner.classList.remove('v-cookie-banner--closed');
				},
			},
		);

		document.addEventListener('scroll', debounce(() => {
			// if scroll distance is more than 10% of the page height
			if (window.scrollY > (document.body.scrollHeight / 10) && !cookieBanner.classList.contains('v-cookie-banner--closed')) {
				cookieBanner.querySelector('.v-cookie-banner__button--accept').click();
			}
		}, 500));

		document.addEventListener('click', (e) => {
			// on internal links
			if (e.target.closest('a') && e.target.closest('a').href.indexOf(window.location.origin) !== -1) {
				setBannerSeen();
			}
		});
	}
};

export default vCookieBanner;
